import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function CakesPage() {

    const heroData = [
        {
          title: "Cakes",
          content: "From classic flavors to modern creations, our cakes are the centerpiece of every celebration. Made with premium ingredients and customized to perfection, they are as beautiful as they are delicious.",
          image: images.CakesHeroImage, 
        },
      ];

    const productData = [
        {
            name: "Classic Vanilla Cake",
            content: "Light and flu y vanilla sponge with a smooth buttercream",
            price: 0,
            image: [
              images.Cake1,
            ]
        },
        {
            name: "Chocolate Fudge Cake",
            content: "Rich, moist chocolate cake with a decadent frosting",
            price: 0,
            image: [
            images.Cake2,
            ]
        },
        {
            name: "Carrot Cake",
            content: "Moist carrot cake with cream cheese frosting and a hint of spice",
            price: 0,
            image: [
            images.Cake3,
            ]
        },
        {
            name: "Red Velvet Cake",
            content: "Velvety red sponge with layers of cream cheese frosting",
            price: 0,
            image: [
              images.Cake1,
            ]
        },
        {
            name: "Hazelnut Chocolate Cake",
            content: "Moist cake infused with hazelnuts, chocolate ganache and topped with crushed hazelnuts",
            price: 0,
            image: [
            images.Cake2,
            ]
        },
        {
            name: "Maple Pecan Cake",
            content: "Buttermilk cake infused with maple syrup, pecan nuts and maple butter frosting",
            price: 0,
            image: [
            images.Cake3,
            ]
        },
        {
            name: "Victoria Cake",
            content: "Traditional sponge filled with whipped cream, jam and fresh berries",
            price: 0,
            image: [
              images.Cake1,
            ]
        },
        {
            name: "Lemon Meringue Berry Cake",
            content: "Meringue cake layered with lemon curd and topped with berries",
            price: 0,
            image: [
            images.Cake2,
            ]
        },
        {
            name: "Banana Cake",
            content: "Moist banana-flavored cake, perfect for any occasion",
            price: 0,
            image: [
            images.Cake3,
            ]
        },
        {
            name: "Date Cake",
            content: "Sweet and rich date cake with warm spices",
            price: 0,
            image: [
            images.Cake3,
            ]
        },
    ]

    const customerFavData = [
      {
        name1: "Carrot Cake",
        image1: [
          images.Cake3,
        ],
        content1: "Moist carrot cake with cream cheese frosting and a hint of spice",
        name2: "Hazelnut Chocolate Cake",
        image2: [
          images.Cake2,
        ],
        content2: "Moist cake infused with hazelnuts, chocolate ganache and topped with crushed hazelnuts"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
